// generated from 44 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const attributedCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("attributed_campaign_filter"),
  comparison_key: z.enum([
    "1", // 32 (72.73%)
    "10", // 10 (22.73%)
    "2", // 1 (2.27%)
    "11", // 1 (2.27%)
    "17",
    // Constants::Comparisons.matches_and_existence (AttributedCampaignFilter#allowed_comparisons)
    "12",
  ]),
  display_name: z.string(),
  // undefined: 4 (9.09%), defined 40 (90.91%)
  // null for a blank comparison (11/12) once allow_nil_blank_filters is on: stored as nil
  // (Filter.enforce_nil_for_blank_comparison) and echoed as raw_value via Filter#get_raw_value
  raw_value: z.string().nullable().optional(),
  value: z.string().nullable(),
  varies_by_app_group: z.literal(true),
});
